import { render } from "./email.vue?vue&type=template&id=663dcdb0"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/email.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "663dcdb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('663dcdb0', __exports__)) {
    console.log('reload')
    api.reload('663dcdb0', __exports__)
  }
  
  module.hot.accept("./email.vue?vue&type=template&id=663dcdb0", () => {
    console.log('re-render')
    api.rerender('663dcdb0', render)
  })

}


export default __exports__